//
//
//
//
//
//

export default {
  name: 'P404'
}



// WEBPACK FOOTER //
// ./src/pages/Page404.vue